const projects = {
  namespaced: true,
  state: {
    displayMap: false,
  },
  mutations: {
    hideMap(state) {
      state.displayMap = false;
    },
    toggleMap(state) {
      state.displayMap = !state.displayMap;
    },
  },
};

export default projects;
